<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Clients ({{ lines }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
            <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
                <button type="button" class="btn " @click.prevent="changeAffichage('table')"
                    :class="{ 'active': affichage === 'table' }">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <button type="button" class="btn " @click.prevent="changeAffichage('card')"
                    :class="{ 'active': affichage === 'card' }">
                    <i class="fa-solid fa-border-all"></i>
                </button>
            </div>
            <div class="px-1">
                <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                    Ajouter un client <i class="fa-solid fa-plus"></i>
                </button>
            </div>

        </template>
        <template #content>
            <DataTableBackend :key="key" :url="this.$store.getters.apiUrl + '/api/utilisateurs?type=client'" :columns="columns"
                :view-mode="affichage" :table="table" selection @row-click="openShowModal"
                @set-selected-rows="getSelection" v-on:set-total-records="updateLines">

            </DataTableBackend>
        </template>
    </yams-template>
</template>

<script>

import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '../NavOperations.vue';
import SelectClient from "./SelectClient.vue";



const FormClient = defineAsyncComponent(() => import('./FormClient.vue'));
const ShowClient = defineAsyncComponent(() => import('./ShowClient.vue'));

export default defineComponent({
    name: 'IndexClient',
    components: { NavOperations, SelectClient },
    data() {
        return {
            key: 1,
            lines: 0,
            affichage: "table",
            table: "clients",
            selection: [],
            columns: [
                {
                    key: 'nom_complet',
                    label: 'Nom et prenom',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'telephone1',
                    label: 'Telephone',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'adresse',
                    label: 'Adresse',
                    exportable: true
                },
                {
                    key: 'commercial_nom',
                    label: 'Commercial',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'created_at',
                    label: 'Enregistré le',
                    // format: 'date',
                    exportable: true
                }
            ],
            selectedClient: null,

        };
    },
    methods: {
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        getSelection(selection) {
            this.selection = selection
        },
        openShowModal(objData) {
            this.$dialog.open(ShowClient, {
                props: {
                    header: "Client ID" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(FormClient, {
                props: {
                    header: "Nouveau client",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        },

        onClientChanged(client) {
            console.log('Client sélectionné:', client);
            this.selectedClient = client;
        },
    },

});
</script>